import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
  SET_PERMISSIONS,
  SET_CUSTOMIZATION,
  SET_LOGO_URL,
  SET_SMALL_LOGO_URL,
} from "./types";

import AuthService from "../services/auth.service";

export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { token: data },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    },
  );
};

export const logout = () => (dispatch) => {
  AuthService.logout();
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  link.href = null;
  dispatch({
    type: LOGOUT,
  });
};

export const setPermissions = (roles) => (dispatch) => {
  dispatch({
    type: SET_PERMISSIONS,
    payload: roles,
  });
};

export const setCustomization = (data) => (dispatch) => {
  dispatch({
    type: SET_CUSTOMIZATION,
    payload: data,
  });
};

export const setLogoUrl = (url) => {
  return {
    type: SET_LOGO_URL,
    payload: url,
  };
};

export const setSmallLogoUrl = (url) => {
  return {
    type: SET_SMALL_LOGO_URL,
    payload: url,
  };
};
